export const styles = () => ({
  container: {
    padding: '16px 10px',
  },
  title: {
    paddingBottom: 16,
  },
});
